import type { FC } from 'react';
import { Fragment } from 'react';
import classNames from 'classnames';

import RoundOutcomeIcon from 'app/components/RoundOutcomeIcon';
import { cssVariable } from 'app/utils/style';
import style from 'app/components/MatchesRecap/RoundsRecap/style.module.scss';

interface Props {
  roundGroup: RoundGroup;
  size: number;
  groupkey: string | number;
}

const RoundsTimeline: FC<Props> = ({ roundGroup, size, groupkey }) => (
  <div className={style.timeline} style={cssVariable('repeat-size', size + 1)}>
    {/* Rounds */}
    {roundGroup.rounds.map(round => {
      const roundKey = `${groupkey}-${round.round_number}`;
      return (
        <Fragment key={roundKey}>
          {/* Teams */}
          {round.teams.map(team => (
            <div key={`${roundKey}-${team.side}`} className={style.teamOutcome}>
              {team.winner && (
                <RoundOutcomeIcon
                  side={team.side}
                  type={round.winner_type}
                  className={style.outcomeIcon}
                />
              )}
            </div>
          ))}
        </Fragment>
      );
    })}
    {roundGroup.teams.map((teamScore, teamIndex) => (
      <div
        className={classNames(style[teamScore.side ?? 'scoreDefault'], style.halfScore)}
        key={teamIndex}
      >
        {teamScore.score}
      </div>
    ))}
  </div>
);

RoundsTimeline.displayName = 'RoundsTimeline';

export default RoundsTimeline;
